module.exports = __webpack_public_path__ + "static/media/newLogo.79ca7f4e.png";